import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeMemoTitleListItem extends SearchModelBase {
    description: string = '';
    id: number = 0;
    code: string = '';
    inactive: boolean = true;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Description', width: 400, dataIndex: 'description'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeMemoTitleListItem.prototype.code, orderByAscending: false };

    public static formatData(data: CodeMemoTitleListItem[]) {
        return data.map((d: CodeMemoTitleListItem) => ({
          ...d,
        }));
    }

}
